<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Table} from 'sveltestrap'
    import {getWalletBalances} from 'src/components/cabinet/#services/nearAdapter'

    function init() {
        getWalletBalances.send({ data: {} })
        $getWalletBalances.value
    }
    $:init()
</script>

<svelte:head>
    <title>Deposit wallets</title>
</svelte:head>

<MainLayout title="Deposit wallets">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="wallets-list">
                    <Table bordered responsive>
                        <thead>
                            <tr>
                                <td class="text-center">Wallet</td>
                                <td class="text-center">Balance</td>
                            </tr>
                        </thead>
                        <tbody>
                        {#if !$getWalletBalances.hasValue && $getWalletBalances.loading}
                            <tr>
                                <td class="text-center" colSpan="3">Loading...</td>
                            </tr>
                        {:else if !$getWalletBalances.hasValue && $getWalletBalances.error }
                            <tr>
                                <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
                            </tr>
                        {:else if $getWalletBalances.value}
                            {#each $getWalletBalances.value as { userId, wallet, balance }}
                                <tr>
                                    <td class="text-center"><a href="/profile/{userId}" target="_blank" rel="noreferrer">{wallet}</a></td>
                                    <td class="text-center">{balance} LIS</td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .wallets-list :global(table) {
        width: auto;
    }

    .wallets-list :global(tbody td) {
        vertical-align: middle;
        padding: 5px 10px;
        line-height: normal;
    }
</style>
